export enum AlertListSubTabs {
	PLANNED_DOWNTIME = 'planned-downtime',
	ROUTING_POLICIES = 'routing-policies',
}

export enum AlertListTabs {
	TRIGGERED_ALERTS = 'TriggeredAlerts',
	ALERT_RULES = 'AlertRules',
	CONFIGURATION = 'Configuration',
	CHANNELS = 'Channels',
}
